var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuportTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150C116.421 150 150 116.421 150 75Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5349 57.0264C94.0728 57.0264 94.5886 57.24 94.969 57.6204C95.3493 58.0007 95.563 58.5165 95.563 59.0544V70.2104C94.218 70.2104 92.9282 70.7446 91.9772 71.6956C91.0262 72.6466 90.4919 73.9365 90.4919 75.2814C90.4919 76.6263 91.0262 77.9161 91.9772 78.8671C92.9282 79.8181 94.218 80.3524 95.563 80.3524V91.5084C95.563 92.0462 95.3493 92.5621 94.969 92.9424C94.5886 93.3227 94.0728 93.5364 93.5349 93.5364H57.0249C56.4871 93.5364 55.9713 93.3227 55.5909 92.9424C55.2106 92.5621 54.9969 92.0462 54.9969 91.5084V80.3524C55.6629 80.3524 56.3223 80.2212 56.9375 79.9664C57.5528 79.7115 58.1118 79.338 58.5827 78.8671C59.0536 78.3962 59.4271 77.8372 59.6819 77.222C59.9368 76.6067 60.0679 75.9473 60.0679 75.2814C60.0679 74.6154 59.9368 73.956 59.6819 73.3408C59.4271 72.7255 59.0536 72.1665 58.5827 71.6956C58.1118 71.2247 57.5528 70.8512 56.9375 70.5964C56.3223 70.3415 55.6629 70.2104 54.9969 70.2104V59.0544C54.9969 58.5165 55.2106 58.0007 55.5909 57.6204C55.9713 57.24 56.4871 57.0264 57.0249 57.0264H93.5349ZM83.3969 69.1964H67.1669V81.3664H83.3969V69.1964Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuportTicket);
export default __webpack_public_path__ + "static/media/suport-ticket.6ff63446b04d04aa417acac66705e9a8.svg";
export { ForwardRef as ReactComponent };